var React = require('react');

function HockeyPuck (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M0 352V242.2c113.5 82.4 398.6 82.3 512 0V352c0 53-114.6 96-256 96S0 405 0 352z","className":"fa-primary","key":2})]);
}

HockeyPuck.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HockeyPuck;

HockeyPuck.default = HockeyPuck;
